import React from 'react';

import { ReactComponent as Logo } from '../../assets/JSX_logo.svg';

import { connect } from 'react-redux';

import { signInStart, signOutStart } from '../../redux/user/user.actions';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/user/user.selector';
import HeaderDrawer from '../header-drawer/header-drawer.component';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import {
  HeaderContainer,
  LogoContainer,
  OptionsContainer,
  OptionLink,
} from './header.styles';

//Send logout signal

const Header = ({ currentUser, signInStart, signOutStart }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm')); //600px

  // const isLarge = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <HeaderContainer>
      <LogoContainer to="/">
        <Logo className="logo" />
      </LogoContainer>
      <OptionsContainer sx={{ display: isSmall ? 'none' : 'flex' }}>
        <OptionLink to="/valet">VALET</OptionLink>
        {/* <OptionLink to="/wirepas">WIREPAS</OptionLink> */}
        {/* <OptionLink to="/security">SECURITY</OptionLink> */}
        <OptionLink to="/customerSupport">CUSTOMER SUPPORT</OptionLink>
        <OptionLink to="/twilio">OCC</OptionLink>
        {/* <OptionLink to="/automations">IT</OptionLink> */}
        {/* <OptionLink to="/maintenance">MAINTENANCE</OptionLink> */}
        {currentUser ? (
          <OptionLink to="/" onClick={signOutStart}>
            SIGN OUT
          </OptionLink>
        ) : (
          <OptionLink
            to="/"
            onClick={() => {
              signInStart();
            }}
          >
            SIGN IN
          </OptionLink>
        )}
      </OptionsContainer>

      {isSmall && (
        <HeaderDrawer>
          <ListItem>
            <OptionLink to="/valet">VALET</OptionLink>
          </ListItem>
          {/* <ListItem><OptionLink to="/wirepas">WIREPAS</OptionLink></ListItem> */}
          <ListItem>
            <OptionLink to="/security">SECURITY</OptionLink>
          </ListItem>
          <ListItem>
            <OptionLink to="/trueblue">CUSTOMER SUPPORT</OptionLink>
          </ListItem>
          <ListItem>
            <OptionLink to="/twilio">OCC</OptionLink>
          </ListItem>
          {/* <ListItem><OptionLink to="/automations">IT</OptionLink></ListItem> */}
          {/* <ListItem><OptionLink to="/maintenance">MAINTENANCE</OptionLink></ListItem> */}
          <ListItem>
            {currentUser ? (
              <OptionLink to="/" onClick={signOutStart}>
                SIGN OUT
              </OptionLink>
            ) : (
              <OptionLink
                to="/"
                onClick={() => {
                  signInStart();
                }}
              >
                SIGN IN
              </OptionLink>
            )}
          </ListItem>
        </HeaderDrawer>
      )}
    </HeaderContainer>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  signInStart: () => dispatch(signInStart()),
  signOutStart: () => dispatch(signOutStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
